import React from 'react';
import './home.css'
import Feedbackmanagement from '../sections/sec-feedback';

const Feedbackkmsg = () => {
    return ( 
        <>
        <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <Feedbackmanagement />
        </section>
        </>
     );
}
 
export default Feedbackkmsg;